import { notifications } from '@mantine/notifications';
import messages from '@shared/constants/messages';
import { safeString } from '@utils/stringUtil';
import { OfflineOrderingState } from '../types';

const removeEditItems = (state: OfflineOrderingState, id: string): OfflineOrderingState => {
  const menuItem = state?.menus?.find((x) => x.tempId === id);

  if (menuItem) {
    if (menuItem?.count && menuItem?.count > 1) {
      return {
        ...state,
        menus:
          state?.menus?.map((item) => {
            if (item.tempId === id) {
              return {
                ...item,
                count: (item.count || 0) - 1,
                orderItemToppings: item?.orderItemToppings?.map((x) => ({
                  ...x,
                  count: (item.count || 0) - 1,
                })),
                toppings: item?.orderItemToppings?.map((x) => ({
                  ...x,
                  count: (item.count || 0) - 1,
                })),
              };
            }
            return item;
          }) || [],
      };
    }

    const orderOrderItems = state?.menus
      ?.filter((x) => x.tempId !== id)
      .reduce((acc, cur) => acc + (cur?.count || 0), 0);
    if (orderOrderItems === 0) {
      notifications.show({
        message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
        color: 'red',
      });
      return state;
    }

    return {
      ...state,
      menus: state?.menus?.filter((x) => x.tempId !== id),
      removedItems: [
        ...(state?.removedItems || []),
        ...(state?.order?.orderItems
          ?.filter((x) => x.id === id)
          .map((item) => ({
            count: item?.count,
            discount: item?.discount || 0,
            menuItemId: item?.menuItemId || '',
            title: item?.title || '',
            price: item?.price || 0,
            packagingCost: item?.packagingCost || 0,
            servePackagingCost: item?.packagingCost || 0,
            tempId: safeString(item?.id),
            orderItemToppings: item?.toppings?.map((x) => ({
              count: item?.count,
              price: x.price,
              title: x.title,
              toppingId: x.id,
            })),
          })) || []),
      ],
    };
  }
  return { ...state };
};

const removeItemByTempId = (state: OfflineOrderingState, tempId: string): OfflineOrderingState => {
  if (state?.isEdited) {
    return removeEditItems(state, tempId);
  }
  const menuItem = state.menus.find((x) => x.tempId === tempId);
  if (menuItem) {
    if (menuItem?.count && menuItem?.count > 1) {
      return {
        ...state,
        menus: state.menus.map((item) => {
          if (item.tempId === tempId) {
            return {
              ...item,
              count: (item.count || 0) - 1,
              orderItemToppings: item?.orderItemToppings?.map((x) => ({
                ...x,
                count: (item.count || 0) - 1,
              })),
            };
          }
          return item;
        }),
      };
    }
    return {
      ...state,
      menus: state.menus.filter((x) => x.tempId !== tempId),
    };
  }
  return state;
};

export default removeItemByTempId;
